import React, { useState } from 'react';

import { Button } from '@ao-internal/components-react';

import TRANSLATIONS from './translations@default.json';

export const ShowMoreButton = ({
	FacetValues,
	initialFacetsToShow,
	showAllFacets,
	resetFacets,
}) => {
	const amountOfMoreOptions = FacetValues.length - initialFacetsToShow.current;

	const [showMore, setShowMore] = useState(false);

	const toggleState = () => {
		if (showMore) {
			resetFacets();
		} else {
			showAllFacets();
		}

		setShowMore(!showMore);
	};

	if (amountOfMoreOptions <= 0) {
		return null;
	}

	return (
		<Button
			variant="link"
			data-testid="show-more-option"
			className="text-xs hover:no-underline focus:no-underline mb-3 mx-3 p-1"
			onClick={() => toggleState()}>
			{TRANSLATIONS.Show} {amountOfMoreOptions}{' '}
			{showMore ? TRANSLATIONS.less : TRANSLATIONS.more} {TRANSLATIONS.options}
		</Button>
	);
};

export default ShowMoreButton;
